"use client";

import ScreenLayout from "@/components/layout/screen-layout";
import { FAQ_Items, FAQ_Section_Heading } from "@/lib/dto/home/faq/faq-data";
import { useState } from "react";

function FaqItem({
  question,
  answer,
  isOpen,
  onToggle,
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
      <button
        onClick={onToggle}
        aria-expanded={isOpen}
        className="w-full flex justify-between items-center gap-4 px-5 py-4 md:px-7 md:py-5 text-left text-custom-blue font-semibold text-base md:text-lg hover:bg-[#F7F8FC] transition-colors"
      >
        <span>{question}</span>
        <span
          className={`flex-shrink-0 w-7 h-7 rounded-full border border-[#5231E7]/20 flex items-center justify-center text-[#5231E7] transition-transform duration-300 ${
            isOpen ? "rotate-45" : "rotate-0"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
        </span>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <p className="px-5 pb-5 md:px-7 md:pb-6 text-gray-600 text-sm md:text-base leading-relaxed border-t border-gray-100 pt-3">
          {answer}
        </p>
      </div>
    </div>
  );
}

function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <ScreenLayout outerClassName="bg-[#F7F8FC]">
      <div className="py-14 md:py-20">
        {/* Heading */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-custom-blue capitalize">
            {FAQ_Section_Heading.heading}
          </h2>
          <p className="mt-3 md:mt-4 text-base md:text-xl text-gray-500 font-normal max-w-xl mx-auto">
            {FAQ_Section_Heading.sub_heading}
          </p>
        </div>

        {/* Accordion */}
        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_Items.map((item, index) => (
            <FaqItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              onToggle={() => toggle(index)}
            />
          ))}
        </div>
      </div>
    </ScreenLayout>
  );
}

export default FaqSection;
